import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  selector: 'app-analysis-header-button',
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class AnalysisHeaderButtonComponent {
  @HostBinding('class.gml-8') margin = true;
}
